import { api } from "~/utils/api";

// Configurable cutoff (appSettings key OFFER_MIN_HOURS_BEFORE_TEE_TIME, default
// 2 hours) — how close to the tee time an offer can still be created, accepted,
// or shown as live instead of expired (ENG-1897 #35). Every client-side spot that
// used to hardcode "24 hours" reads this instead, so they all stay in sync with
// the same server-side enforcement in nameYourPriceOffer.service.ts /
// bookingOffer.service.ts.
export const useMinHoursBeforeTeeTime = () => {
  const { data, isLoading } = api.nameYourPriceOffer.getMinHoursBeforeTeeTime.useQuery();
  return { minHours: data ?? 2, isLoading };
};
